//  import React from 'react'
import styled from '@emotion/styled'

import tokens from '../../design/tokens'
import colorNames from '../../design/color-names'

export const StyledThumb = styled.div`
  label: e-thumb;
  ${({ $aspectRatio }) =>
    $aspectRatio ? `aspect-ratio: ${$aspectRatio};` : ''};
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  background-color: ${colorNames.pureWhite};

  img {
    max-width: 100%;
    width: 100%;
  }
`

export const StyledThumbOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  opacity: 0;
  color: ${colorNames.pureWhite};

  transition: all 0.35s ease;

  :hover {
    opacity: 1;
    background-color: rgba(37, 37, 37, 0.9);
    cursor: pointer;
  }

  a,
  a:hover {
    font-weight: ${tokens.fontWeight.normal};
    text-decoration: none;
  }

  & > * {
    transform: translateY(-8px);
    transition: all 0.35s ease;
  }

  :hover > * {
    transform: translateY(0px);
  }
`

export const StyledThumbOverlayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StyledIconWrapper = styled.div`
  ${({ $width }) => ($width ? `width: ${$width}px;` : '')}
  ${({ $height }) => ($height ? `height: ${$height}px;` : '')}

  ${({ $fill }) => ($fill ? `color: ${$fill};` : '')}
  
  & + .e-thumb-overlay-container__content {
    margin-top: ${tokens.spacing.baseN}px;
  }
  
`

export const StyledThumbOverlayContent = styled.div`
  font-weight: ${tokens.fontWeight.bold};
  font-size: ${tokens.fontSize.small};

  color: ${colorNames.pureWhite};
`

export const StyledErrorContent = styled.a`
  font-weight: ${tokens.fontWeight.bold};
  font-size: ${tokens.fontSize.small};

  color: ${colorNames.gray};
  cursor: pointer;
  text-decoration: underline;

  transition: color 0.25s ease;

  &:hover {
    color: ${colorNames.blueChill};
    text-decoration: underline;
  }
`

export const StyledThumbDefaultUploadedImage = styled.div`
  padding: ${3 * tokens.spacing.baseN}px;
  max-height: ${200 + 6 * tokens.spacing.baseN}px;

  display: flex;

  img {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 200px;
  }
`
